import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import {Observable} from 'rxjs/index';

import { Configuration as config } from '../../main/configuration/main.config';
import {ActivityLog} from '../../main/models/activity-log';

@Injectable()
export class EntitiesService {

  constructor(private http: HttpClient) {}

  getItems(name: string) {
    const url = `${config.apiUrl}/${config.urls[name].get}`;

    return this.http.get(url).pipe(map((res: any) => res.data || res));
  }

  addRecords(type: string, id: string, data) {
    const url = `${config.apiUrl}/${config.urls.activityRecord.add(type, id)}`;
    return this.http.post(url, data);
  }

  getCustomerUserProjects(customerId?: string, userId?: string) {
    const url = `${config.apiUrl}/${config.urls.activityRecord.userCustomerProjects(customerId, userId)}`;

    return this.http.get(url);
  }

  getPartnerProjects(partnerId?: string) {
    const url = `${config.apiUrl}/${config.urls.activityRecord.partnerProjects(partnerId)}`;

    return this.http.get(url);
  }

  getActivityLogFor(type: string, targetId: string): Observable<{data: ActivityLog[]}> {
    const url = `${config.apiUrl}/${config.urls.activityRecord.getActivityLogFor(type, targetId)}`;

    return this.http.get<{data: ActivityLog[]}>(url);
  }

  getActivityRecords(query = {}): Observable<{data: ActivityLog[], count: number}> {
    const qs = Object.keys(query).map(key => key + '=' + query[key]).join('&');
    const url = `${config.apiUrl}/${config.urls.activityRecord.getActivityRecords}?${qs}`;

    return this.http.get<{data: ActivityLog[], count: number}>(url);
  }

  deleteActivityLog(id: string) {
    const url = `${config.apiUrl}/${config.urls.activityRecord.delete}/${id}`;

    return this.http.delete(url);
  }

  updateActivityLog(id: string, log: ActivityLog) {
    const url = `${config.apiUrl}/${config.urls.activityRecord.update}/${id}`;

    return this.http.put(url, log);
  }

  getAdminNames() {
    return this.http.get(`${config.apiUrl}/${config.urls.getAdminName}`);
  }

  markLogAsDone(activityId: string) {
    const url = `${config.apiUrl}/${config.urls.activityRecord.markAsDone(activityId)}`;

    return this.http.put(url, {});
  }

  getUsersByIds(ids: string[]) {
    const url = `${config.apiUrl}/${config.urls.user.get}`;

    return this.http.get(`${url}?ids=${ids.join('|')}`);
  }
}
